import { CheckCircle, Clock, Slash, XCircle } from "react-feather";
import styles from "./approval.module.css";
import { getApproval, pendingUpdateLabel } from "./vehicleRows";

const TONES = {
  pending: { className: styles.Pending, Icon: Clock },
  approved: { className: styles.Approved, Icon: CheckCircle },
  rejected: { className: styles.Rejected, Icon: XCircle },
  disabled: { className: styles.Disabled, Icon: Slash },
};

// Approval badge for a vehicle row (list, grid card, mobile card), with optional subline and update notice
const ApprovalBadge = ({ row, showSub = true, showUpdate = true }) => {
  const approval = getApproval(row);
  const tone = TONES[approval.state] || TONES.disabled;
  const Icon = tone.Icon;

  return (<div className={styles.ApprovalCell}>
    <span className={`${styles.Badge} ${tone.className}`}>
      <Icon size={12} />
      {approval.label}
    </span>
    {showSub && approval.sub && <span className={styles.Sub}>{approval.sub}</span>}
    {showUpdate && row?.pending_update && (<span className={`${styles.Badge} ${styles.Pending} ${styles.Small}`}>
      <Clock size={11} />
      {pendingUpdateLabel(row)}
    </span>)}
  </div>);
};

export default ApprovalBadge;
